import React, { useState } from "react";
import Close_Button from "../../../assets/png/close.png";
import { Grid, Radio, TextField, Typography } from "@mui/material";
import { HERE_ABOUT_US_MAPPINGS } from "../../../utils";
import RoundButton from "../../../components/RoundButton";
import storePersist, { localConstant } from "../../../services/localStorage";

export const HereAboutUsModal = ({
  setHereAbotUsModalFunc,
  getDataFromHereAboutUS,
}) => {
  const [seletedValue, setSelectedValue] = useState(
    HERE_ABOUT_US_MAPPINGS[1]?.id,
  );
  const userId = storePersist.get(localConstant.USER_ID);
  const [otherTextValue, setOtherTextValue] = useState("");
  let timer = null;
  const setOtherSelectedTextValue = (value) => {
    //  debounce function to avoid extra set state calls ...
    clearTimeout(timer);
    timer = setTimeout(() => {
      setOtherTextValue(value);
    }, 600);
  };

  const onSubmitHereAboutUs = () => {
    let body = {
      userId: userId,
      userReferralSource: seletedValue,
      userReferralComments: null,
    };
    if (seletedValue === "OTHER") {
      body = { ...body, userReferralComments: otherTextValue };
    }
    getDataFromHereAboutUS(body);
  };
  return (
    <Grid
      width={{ xs: "90vw", md: "50vw" }}
      style={{
        backgroundColor: "white",
        padding: "30px 15px 30px 15px",
        borderRadius: "10px",
      }}
      maxHeight={"80vh"}
      overflow={"scroll"}
    >
      <Grid display={"flex"} justifyContent={"space-between"} marginBottom={1}>
        <Grid display={"flex"} alignItems={"center"}>
          <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>
            How Did You Hear About Us ?
          </Typography>
        </Grid>
        <Grid
          padding={1}
          style={{
            cursor: "pointer",
          }}
          onClick={() => setHereAbotUsModalFunc(false)}
        >
          <img src={Close_Button} style={{ height: 10, width: 10 }} />
        </Grid>
      </Grid>
      {HERE_ABOUT_US_MAPPINGS.map((item, idx) => {
        return (
          <Grid borderRadius={1} display={"flex"} marginTop={idx === 0 ? 0 : 2}>
            <Grid
              display={"flex"}
              alignItems={"center"}
              border={"1px solid grey"}
              width={"100vw"}
              borderRadius={1}
            >
              <Radio
                checked={item.id === seletedValue}
                onChange={(e) => {
                  setSelectedValue(e.target.value);
                }}
                value={item.id}
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
              />
              <Typography fontSize={"14px"} style={{ fontFamily: "Segoe UI" }}>
                {item.title}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
      {seletedValue === "OTHER" && (
        <Grid marginTop={2}>
          <TextField
            id="outlined-basic"
            label="Other ..."
            variant="outlined"
            fullWidth
            style={{
              height: "20px",
            }}
            onChange={(e) => {
              setOtherSelectedTextValue(e.target.value);
            }}
          />
        </Grid>
      )}
      {seletedValue === "OTHER" && otherTextValue?.length === 0 && (
        <Typography
          marginTop={"35px"}
          color="red"
          fontSize={"14px"}
          marginLeft={"5px"}
        >
          Other Value Should Not Be Empty
        </Typography>
      )}

      <RoundButton
        paddingBottom={10}
        sx={{ mt: otherTextValue?.length === 0 ? 2 : 5, mb: 3 }}
        size="large"
        fullWidth
        variant="contained"
        onClick={() => onSubmitHereAboutUs()}
        color="primary"
        rounded
        disabled={seletedValue === "OTHER" && otherTextValue?.length === 0}
      >
        <Typography variant="buttonText" color="common.buttonText">
          Submit
        </Typography>
      </RoundButton>
    </Grid>
  );
};
